import { jsx as _jsx } from "react/jsx-runtime";
import { HcLoading } from '@hotmart-org-ca/cosmos-web/dist/react/hc-loading';
import clsx from 'clsx';
export function Loader({ children, full, ariaLabel, className, 'data-testid': dataTest }) {
    const style = clsx('flex items-center justify-center', {
        'w-full': full === 'width',
        'h-full w-full': full === 'screen'
    }, className);
    return (_jsx("div", { className: style, "data-testid": dataTest, children: _jsx(HcLoading, { ariaLabel: ariaLabel, children: children }) }));
}
